#import "../shift/shiftInfo.gql"

fragment defaultAvailabilityInfo on DefaultAvailability {
  line {
    id
    name
  }
  shift {
    ...shiftInfo
  }
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
}
